import { Control } from '@yleisradio/areena-types';
import classNames from 'classnames';
import { MenuItem } from 'components/AreenaMenu/SubMenu/MenuItem';
import styles from './MobileMenuSection.module.scss';
import { FunctionComponent } from 'react';

export enum MenuType {
  PersonalMenu = 'personalMenu',
  TrailingMenu = 'trailingMenu',
}
type Props = {
  controls: Control[];
  menuType: MenuType;
  toggleSubMenu(): void;
};

export const MobileMenuSection: FunctionComponent<Props> = ({
  controls,
  menuType,
  toggleSubMenu,
}) => {
  if (!controls || controls.length === 0) {
    return null;
  }
  return (
    <ul className={classNames(styles.mobileMenuSection, styles[menuType])}>
      {controls.map((control) => (
        <MenuItem
          key={control.title}
          item={control}
          toggleSubMenu={toggleSubMenu}
        />
      ))}
    </ul>
  );
};
